import { Component, OnInit } from '@angular/core';
import * as e from 'express';
import { ActivatedRoute, Router } from '@angular/router';
import { mainData } from 'src/app/shared/interface/main-data';
import { AritcleService } from 'src/app/shared/services/article.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { ETFService } from 'src/app/shared/services/etf.service';
import { FundService } from 'src/app/shared/services/fund.service';
import { EnumStatusCode } from 'src/app/enum/enumStatusCode';
import { FundCategoryReq, FundComposition, FundRecordDate, FundSelectList, FundYieldList, FundYieldReq, GetNavCompositionRes } from 'src/app/shared/models/fund';
import { IDPreview } from 'src/app/shared/models/base';

@Component({
  selector: 'app-exchange-trad',
  standalone: false,
  templateUrl: './exchange-trad.component.html',
  styleUrl: './exchange-trad.component.scss'
})
export class ExchangeTradComponent {
  TotalItems = 0;
  isSubmit = false; //是否搜尋過

  //tab
  activeIndex: number = 0;

  //基金配息Req
  fundYieldReq: FundYieldReq = {} as FundYieldReq;
  //基金配息
  fundYieldList: FundYieldList[] = [];
  //配息組成
  FundComposition: FundComposition[] = [];
  //配息基準日
  FundRecordDate:FundRecordDate[]=[];
  //淨值組成
  NavComposition: GetNavCompositionRes[] = [];

  //下拉用
  iDPreview: IDPreview = {} as IDPreview;
  fundSelectList: FundSelectList[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public baseService: BaseService,
    public fundService: FundService,
    public etfService: ETFService,
    public aritcleService: AritcleService,
    public mainData$: mainData,
  ) {
    this.fundYieldReq.PageIndex = 1;
    this.fundYieldReq.PageSize = 10;
    this.GetFundSelectList(0);
    this.route.url.subscribe(urlSegments => {
      const currentPath = urlSegments[0].path;
      if (currentPath === 'fund-dividend') {
        this.activeIndex = 0;
      } else if (currentPath === 'dividend-composition') {
        this.activeIndex = 1;
      }
      else if (currentPath === 'dividend-date') {
        this.activeIndex = 2;
      }
      else if (currentPath === 'net-composition') {
        this.activeIndex = 3;
      }
      this.fundYieldReq.IsETFYieldPage = true;
      this.submit();
    });
  }

  ngOnInit(): void {

  }

  selectChange(e: any) {
    if (this.activeIndex == 0) {
      this.router.navigate(['etf/fund-dividend'])
    }
    else if (this.activeIndex == 1) {
      this.router.navigate(['etf/dividend-composition'])
    }
    else if (this.activeIndex == 2) {
      this.router.navigate(['etf/dividend-date'])
    }
    else if (this.activeIndex == 3) {
      this.router.navigate(['etf/net-composition'])
    }
  }

  //取得基金配息
  GetNewestFundYieldList() {
      this.fundService.GetNewestFundYieldList(this.fundYieldReq).subscribe((res) => {
        if (res.StatusCode == EnumStatusCode.Success) {
          this.fundYieldList = res.Entries;
          this.TotalItems = res.TotalItems;
        }
        this.mainData$.loading$.next(false);
        this.isSubmit = true;
      });
  }

  //取得配息組成
  GetNewestGetFundComposition() {
    this.fundService.GetFundComposition(this.fundYieldReq).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.FundComposition = res.Entries;
        this.TotalItems = res.TotalItems;
      }
      this.isSubmit = true;
      this.mainData$.loading$.next(false);
    });
  }

  //取得配息基準日
  GetNewesGetFundRecordDaten() {
    this.fundService.GetFundRecordDate(this.fundYieldReq).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.FundRecordDate = res.Entries;
        this.TotalItems = res.TotalItems;
      }
      this.isSubmit = true;
      this.mainData$.loading$.next(false);
    });
  }

  //取得淨值組成
  GetNavComposition() {
    this.fundService.GetNavComposition(this.fundYieldReq).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.NavComposition = res.Entries;
        this.TotalItems = res.TotalItems;
      }
      this.mainData$.loading$.next(false);
      this.isSubmit = true;
    });
  }

  //取得下拉選單
  GetFundSelectList(id: number) {
    this.iDPreview.TypeID = id;
    this.iDPreview.FundFilter = 'IndexETF';
    this.fundService.GetFundSelectList(this.iDPreview).subscribe((res) => {
      if (res.StatusCode == EnumStatusCode.Success) {
        this.fundSelectList = res.Entries;
        let filteredList  = this.fundSelectList.filter(x => x.IsETF);

        //全部
        const allOption = {
          FundNo: '',
          FundFullName: '全部',
          FundShortName: '全部',
          IsETF: true
        }
        this.fundSelectList = [allOption, ...filteredList];
      }
      this.mainData$.loading$.next(false);
    });
  }

  submit(e?: any) {
    this.fundYieldReq.Keyword = e?.Keyword || '';
    this.fundYieldReq.TypeIDs = [];
    this.fundYieldReq.AreaIDs = [];
    this.fundYieldReq.RiskLvIDs = [];
    this.fundYieldReq.DividendIDs = [];
    this.fundYieldReq.CurrencyTypeIDs = [];
    this.fundYieldReq.YearList = [];
    this.fundYieldReq.StartDate = e?.StartDate || null;
    this.fundYieldReq.EndDate = e?.EndDate || null;
    this.getSubmit();
  }

  getSubmit() {
    if(this.activeIndex == 0){
      this.GetNewestFundYieldList();
    }else if(this.activeIndex == 1){
      this.GetNewestGetFundComposition();
    }else if(this.activeIndex == 2){
      this.GetNewesGetFundRecordDaten();
    }else if(this.activeIndex == 3){
      this.GetNavComposition();
    }
  }

  //搜尋
  onSearch(event: any) {
    const fundNo = event.selectedFund.FundNo;
    const searchReq = {
      Keyword: fundNo,
      StartDate: event.startDate,
      EndDate: event.endDate
    }
    this.fundYieldReq.PageSize = 10;
    this.submit(searchReq);
  }

  more() {
    this.fundYieldReq.PageSize = this.fundYieldReq.PageSize + 10;
    this.submit();
  }

  goFundPage(no: string) {
    this.router.navigate(['/etf/etf-info/' + no], {
      queryParams: {
        tab: 1
      }
    })
  }
}
